import { render, staticRenderFns } from "./OrderProductStatistics.vue?vue&type=template&id=425dabc5&scoped=true&"
import script from "./OrderProductStatistics.vue?vue&type=script&lang=js&"
export * from "./OrderProductStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425dabc5",
  null
  
)

export default component.exports